import { LineChart, Line, ResponsiveContainer } from 'recharts';

export default function WinRateSparkline({ data }) {
  // data: array of { match_number, win_rate }
  const chartData = (data || []).filter(d => d.win_rate !== null && d.win_rate !== undefined).map(d => ({
    match: d.match_number,
    win: d.win_rate * 100
  }));
  if (!chartData.length) return <div className="text-gray-400 text-xs">No trend</div>;
  return (
    <ResponsiveContainer width="100%" height={32}>
      <LineChart data={chartData} margin={{ top: 8, right: 0, left: 0, bottom: 8 }}>
        <Line type="monotone" dataKey="win" stroke="#2563eb" strokeWidth={2} dot={false} />
      </LineChart>
    </ResponsiveContainer>
  );
}
